import React from "react";

import { ClipLoader } from "react-spinners";

const pStyle = {
  marginTop: "15vh"
};

class LoadingBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  render() {
    return (
      <div className="sweet-loading">
        <center style={pStyle}>
          <ClipLoader size={50} loading={this.state.loading} />
        </center>
      </div>
    );
  }
}

export default LoadingBox;
